var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"flat":""},on:{"click":_vm.toggleSidebar}},[_c('v-icon',[_vm._v("info")]),_c('span',{staticClass:"ml-2"},[_vm._v("Ejemplos")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }